import React from 'react'

export default function NoPdfFound() {
    return (
        <div className="no-pdf-found">
            <p>Content will be provided soon. Please come back later</p>
        </div>
    )
}
